import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class HoverboxService {
  public cursorPos: {
    x: number;
    y: number;
  } = {
    x: 0,
    y: 0,
  };

  public cursorPos$: BehaviorSubject<any> = new BehaviorSubject(this.cursorPos);
}
